module.exports = "/images/sv.svg?22850f96d06e96e79b6a72e4ef23428a";